import type {
  AlunoCreateInputType,
  AlunoOutputType,
  AlunoUpdateInputType,
  MatriculaOutputType,
} from '../../../shared/dto';
import { callApi } from './call-api';

export const alunosApi = {
  listar: (_args: void) => callApi<AlunoOutputType[]>({ path: '/alunos' }),

  buscar: (id: string) => callApi<AlunoOutputType>({ path: `/alunos/${id}` }),

  criar: (body: AlunoCreateInputType) =>
    callApi<AlunoOutputType>({
      method: 'POST',
      path: '/alunos',
      body,
    }),

  atualizar: ({ id, dados }: { id: string; dados: AlunoUpdateInputType }) =>
    callApi<AlunoOutputType>({
      method: 'PUT',
      path: `/alunos/${id}`,
      body: dados,
    }),

  listarMatriculas: (alunoId: string) =>
    callApi<MatriculaOutputType[]>({
      path: `/alunos/${alunoId}/matriculas`,
    }),
};
